import { Action } from './Action'
import { Corpus } from './Corpus'
import { Detail } from './Detail'
import { ExternalLink } from './ExternalLink'
import { Section } from './Section'
import { SmallDetail } from './SmallDetail'
import { SubTitle } from './SubTitle'
import { Title } from './Title'

export type BaseProps = {
  inline?: boolean
  element?: string
  href?: string
  to?: string
  className: string
  style?: React.CSSProperties
  children: React.ReactNode
}

export type MakeTextComponentProps = {
  children: React.ReactNode
  className?: string
  inline?: boolean
  href?: string
  to?: string
  style?: React.CSSProperties
  onClick?: () => void
}
export const Text = {
  Title,
  SubTitle,
  Corpus,
  Section,
  Detail,
  SmallDetail,
  Action,
  ExternalLink,
}
